import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/ase.png"
      {...props}
    />
  );
}

export default Logo;
